import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertaTipo4Component } from './alerta-tipo4.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ AlertaTipo4Component ],
  exports: [ AlertaTipo4Component ]
})
export class AlertaTipo4Module { }
